<div class="summary-send-container">
  <!-- Content Before Submission -->
  <div *ngIf="!submitted" class="content-before-submit">
    <!-- Left Side - Guest & Budget Info -->
    <div class="left-side">
      <!-- Guest Info Card -->
      <mat-card class="info-card guest-info-card">
        <div class="card-header">
          <mat-icon class="header-icon">person</mat-icon>
          <h3 class="card-title">Podaci o gosta</h3>
        </div>
        <mat-card-content>
          <div class="info-grid">
            <div class="info-item full-width">
              <div class="info-label">
                <mat-icon>badge</mat-icon>
                Tip gosta
              </div>
              <div class="info-value">
                <mat-chip [class.valamar-chip]="isValamarGuest">
                  {{ isValamarGuest ? 'Valamar gost' : 'External' }}
                </mat-chip>
                <mat-chip *ngIf="vLevel" class="vlevel-chip">
                  <mat-icon>workspace_premium</mat-icon>
                  V-Level (100%)
                </mat-chip>
                <mat-chip *ngIf="isValamarGuest && !vLevel" class="valamar-standard">
                  <mat-icon>card_membership</mat-icon>
                  Standard (60%)
                </mat-chip>
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <mat-icon>person</mat-icon>
                Ime i prezime
              </div>
              <div class="info-value">{{ getGuestName() }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <mat-icon>email</mat-icon>
                Email
              </div>
              <div class="info-value">{{ reservation?.email }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <mat-icon>login</mat-icon>
                Dolazak
              </div>
              <div class="info-value">{{ parseDate(reservation?.startDate) }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <mat-icon>logout</mat-icon>
                Odlazak
              </div>
              <div class="info-value">{{ parseDate(reservation?.endDate) }}</div>
            </div>

            <div *ngIf="isValamarGuest && valamarBooking" class="info-item full-width">
              <div class="info-label">
                <mat-icon>hotel</mat-icon>
                Valamar podaci
              </div>
              <div class="info-value">
                <span class="valamar-info">{{ valamarBooking.property }}</span>
                <span class="room-info">Soba {{ valamarBooking.roomNumber }}</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Budget Card -->
      <div *ngIf="isTodayReservation()">
        <mat-card class="info-card budget-card">
          <div class="card-header">
            <mat-icon class="header-icon">account_balance_wallet</mat-icon>
            <h3 class="card-title">{{ displayDate }}</h3>
          </div>
          <mat-card-content>
            <div class="budget-summary">
              <div class="budget-row main">
                <div class="budget-label">Ukupna cijena</div>
                <div class="budget-value">{{ dailyBudget.toFixed(2) }} {{ currency }}</div>
              </div>

<!--              <div class="budget-row discount">-->
<!--                <div class="budget-label">Cijena na ležaljke</div>-->
<!--                <div class="budget-value discount-value">{{ (dailyBudget - availableBudget).toFixed(2) }} {{ currency }}</div>-->
<!--              </div>-->

<!--              <div class="budget-row credit">-->
<!--                <div class="budget-label">Dostupni kredit</div>-->
<!--                <div class="budget-value credit-value">-->
<!--                  {{ availableBudget.toFixed(2) }} {{ currency }}-->
<!--                  <span class="budget-badge" [class]="budgetClass">{{ budgetPercentage }}%</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="budget-row credit">-->
<!--                <div class="budget-label">Dostupni kredit</div>-->
<!--                <div class="budget-value credit-value">-->
<!--                  {{ availableBudget.toFixed(2) }} {{ currency }}-->
<!--                  <span class="budget-badge" [class]="budgetClass">{{ budgetPercentage }}%</span>-->
<!--                </div>-->
<!--              </div>-->
            </div>

<!--            <div class="budget-bar-container">-->
<!--              <div class="budget-bar">-->
<!--&lt;!&ndash;                <div class="budget-fill" [class]="budgetClass" [style.width.%]="budgetPercentage"></div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->

          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Right Side - Groups & Actions -->
    <div class="right-side">
      <!-- Groups Statistics -->
      <mat-card class="info-card stats-card">
        <div class="card-header">
          <mat-icon class="header-icon">groups</mat-icon>
          <h3 class="card-title">Pregled</h3>
        </div>
        <mat-card-content>
          <div class="stats-grid">
            <div class="stat-item groups-stat">
              <div class="stat-icon">
                <mat-icon>folder</mat-icon>
              </div>
              <div class="stat-value">{{ todayMasterCards.length }}</div>
              <div class="stat-label">Grupa</div>
            </div>

            <div class="stat-item chairs-stat">
              <div class="stat-icon">
                <mat-icon>event_seat</mat-icon>
              </div>
              <div class="stat-value">{{ totalChairs }}</div>
              <div class="stat-label">Ležaljki</div>
            </div>

            <div class="stat-item wristbands-stat">
              <div class="stat-icon">
                <mat-icon>watch</mat-icon>
              </div>
              <div class="stat-value">{{ totalWristbands }}</div>
              <div class="stat-label">Narukvice</div>
            </div>

            <div class="stat-item budget-stat">
              <div class="stat-icon">
                <mat-icon>account_balance_wallet</mat-icon>
              </div>
              <div class="stat-value">{{ totalCredit.toFixed(2) }}</div>
              <div class="stat-label">EUR</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Groups List -->
      <mat-card class="info-card groups-list-card">
        <div class="card-header">
          <mat-icon class="header-icon">list_alt</mat-icon>
          <h3 class="card-title">Detalji grupa</h3>
        </div>
        <mat-card-content>
          <div class="groups-list">
            <div *ngFor="let masterCard of todayMasterCards" class="group-item">
              <div class="group-item-header">
                <div class="group-name">
                  <mat-icon>folder_open</mat-icon>
                  {{ masterCard.name }} : <span class="group-id">{{ masterCard.id }}</span>
<span class="group-status" [class.active]="masterCard.isActive">{{ masterCard.isActive ? 'aktivna' : 'neaktivna' }}</span>
                </div>
                <div class="group-budget">
                  <span class="balance-label">Preostalo:</span>
                  <span class="balance-value">{{ masterCard.balance?.toFixed(2) ?? '0.00' }} {{ currency }}</span>
                </div>
              </div>

              <div class="group-details">
                <div class="group-detail">
                  <mat-icon>event_seat</mat-icon>
                  <span class="detail-label">Ležaljke:</span>
                  <div class="tags-container">
                    <ng-container *ngFor="let sunbed of masterCard.sunbeds">
                      <!-- Edit mode -->
                      <span *ngIf="isEditingSunbed(masterCard.id, sunbed.id)" class="tag-item chair-tag chair-edit-tag">
                        <input
                          type="text"
                          [(ngModel)]="editedSunbedNumber"
                          (keydown)="onSunbedEditKeyDown($event, masterCard.id, sunbed.id)"
                          class="sunbed-number-input"
                        />
                        <button
                          mat-icon-button
                          (click)="saveSunbedNumber(masterCard.id, sunbed.id)"
                          class="sunbed-edit-btn save-btn"
                        >
                          <mat-icon>check</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          (click)="cancelSunbedEdit()"
                          class="sunbed-edit-btn cancel-btn"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </span>
                      <!-- Display mode -->
                      <span *ngIf="!isEditingSunbed(masterCard.id, sunbed.id)" class="tag-item chair-tag">
                        {{ sunbed.type }} br. {{ sunbed.number || sunbed.id }}
                        <button
                          *ngIf="isTodayReservation(masterCard.transferDate) && masterCard.isActive"
                          mat-icon-button
                          class="edit-sunbed-btn"
                          (click)="startEditingSunbed(masterCard.id, sunbed.id)"
                          matTooltip="Uredi broj ležaljke"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                      </span>
                    </ng-container>
                  </div>
                </div>

                <div class="group-detail">
                  <mat-icon>watch</mat-icon>
                  <span class="detail-label">Narukvice:</span>
                  <div class="tags-container">
                    <span *ngFor="let card of masterCard.additionalCards" class="tag-item wristband-tag">
                      {{ card.id }}
                      <button
                        mat-icon-button
                        class="delete-btn"
                        [disabled]="isDeleting(masterCard.id, card.id) || !isTodayReservation(masterCard.transferDate) || !masterCard.isActive"
                        (click)="deleteAdditionalCard(masterCard.id, card.id)"
                        matTooltip="Obriši narukvicu"
                      >
                        <mat-icon [class.spinning]="isDeleting(masterCard.id, card.id)">close</mat-icon>
                      </button>
                    </span>

                    <!-- Add new wristband input -->
                    <ng-container *ngIf="isAddingCard[masterCard.id]; else showAddButton">
                      <input
                        #additionalCardInput
                        type="text"
                        class="add-wristband-input"
                        placeholder="ID narukvice..."
                        [disabled]="isCreatingCard[masterCard.id]"
                        (keyup.enter)="createAdditionalCard(masterCard.id, additionalCardInput.value)"
                        (keyup.escape)="cancelAddingCard(masterCard.id); additionalCardInput.value = ''"
                      />
                      <button
                        mat-icon-button
                        class="confirm-add-btn"
                        [disabled]="!additionalCardInput.value || isCreatingCard[masterCard.id]"
                        (click)="createAdditionalCard(masterCard.id, additionalCardInput.value); additionalCardInput.value = ''"
                      >
                        <mat-icon [class.spinning]="isCreatingCard[masterCard.id]">check</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        class="cancel-add-btn"
                        [disabled]="isCreatingCard[masterCard.id]"
                        (click)="cancelAddingCard(masterCard.id); additionalCardInput.value = ''"
                        matTooltip="Otkaži"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </ng-container>

                    <ng-template #showAddButton>
                      <button
                        mat-icon-button
                        class="add-wristband-btn"
                        [disabled]="!isTodayReservation(masterCard.transferDate) || !masterCard.isActive"
                        (click)="showAddCardInput(masterCard.id)"
                        matTooltip="Dodaj narukvicu"
                      >
                        <mat-icon>add</mat-icon>
                      </button>
                    </ng-template>
                  </div>
                </div>

                <div class="group-budget-details">
                  <div class="budget-detail">
                    <span class="detail-label">Inicijalni iznos na grupu:</span>
                    <span class="detail-value">{{ masterCard.initialBalance?.toFixed(2) ?? '0.00' }} {{ currency }}</span>
                  </div>
                  <div class="budget-detail">
                    <span class="detail-label">Dozvoljeno prekoračenje:</span>
                    <span class="detail-value overdraft">{{ masterCard.allowedOverdraft?.toFixed(2) ?? '0.00' }} {{ currency }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Error Message -->
      <div *ngIf="error" class="error-message">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error }}</span>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button *ngIf="!dailyCheckinCompleted" mat-button (click)="onBack()" [disabled]="loading" class="btn-back">
          <mat-icon>arrow_back</mat-icon>
          Natrag
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="loading"
          class="btn-submit"
        >
          <mat-icon *ngIf="!loading">send</mat-icon>
          <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
          <span *ngIf="!loading">Završi</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Success State -->
  <div *ngIf="submitted" class="success-container">
    <div class="success-card">
      <div class="success-icon-wrapper">
        <div class="success-icon">
          <mat-icon>check_circle</mat-icon>
        </div>
      </div>
      <h2 class="success-title">Uspješno odrađen check-in!</h2>
      <p class="success-message">{{ successMessage }}</p>

      <div class="success-details">
        <div class="detail-row">
          <div class="detail-label">
            <mat-icon>person</mat-icon>
            Gost:
          </div>
          <div class="detail-value">{{ reservation?.name }}</div>
        </div>

        <div class="detail-row">
          <div class="detail-label">
            <mat-icon>groups</mat-icon>
            Grupe:
          </div>
          <div class="detail-value">{{ todayMasterCards.length }}</div>
        </div>

        <div class="detail-row">
          <div class="detail-label">
            <mat-icon>watch</mat-icon>
            Narukvice:
          </div>
          <div class="detail-value">{{ totalWristbands }}</div>
        </div>

        <div class="detail-row">
          <div class="detail-label">
            <mat-icon>event_seat</mat-icon>
            Ležaljke:
          </div>
          <div class="detail-value">{{ totalChairs }}</div>
        </div>

        <div class="detail-row total-row">
          <div class="detail-label">
            <mat-icon>account_balance_wallet</mat-icon>
            Ukupno kredit:
          </div>
          <div class="detail-value total-value">{{ totalCredit.toFixed(2) }} {{ currency }}</div>
        </div>

        <div class="cards-balance-section">
          <h4 class="section-title">
            <mat-icon>receipt_long</mat-icon>
            Stanje po karticama
          </h4>
          <ul class="cards-balance-list">
            <li *ngFor="let card of todayMasterCards" class="card-balance-item">
              <div class="card-info">
                <mat-icon class="card-icon">credit_card</mat-icon>
                <div class="card-details">
                  <span class="card-id">{{ card.id }}</span>
                  <span class="card-balance">{{ card.balance.toFixed(2) }} {{ currency }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

      </div>

      <div class="success-actions">
        <button
          mat-raised-button
          color="primary"
          (click)="onNewCheckIn()"
          class="btn-new-checkin"
        >
          <mat-icon>add_circle</mat-icon>
          Nova prijava
        </button>
      </div>
    </div>
  </div>

  <!-- Loading Overlay -->
  <app-loading
    *ngIf="loading"
    message="Spremanje podataka..."
    [overlay]="true"
  ></app-loading>
</div>
